// import Vue from 'vue'
import Vue from 'vue'
import {
  GET_COMPANIES,
  ADD_COMPANY,
  UPDATE_COMPANY,
  DELETE_COMPANY,
  REQUEST_COMPANY,
  REQUEST_COMPANY_GET,
  ERROR_XHR
} from '../mutation-types'

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getCompanies = ({ dispatch }, contactId) => {
  dispatch(REQUEST_COMPANY_GET)
  return new Promise((resolve, reject) => {
    Vue.http
      .get('company/contact/' + contactId)
      .then(
        (response) => {
          dispatch(GET_COMPANIES, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

/**
 * Add a new contact
 * @param dispatch
 * @param contact
 */
export const addCompany = ({ dispatch }, company) => {
  dispatch(REQUEST_COMPANY)
  Vue.http
    .post('company', company)
    .then(
      (response) => {
        let data = response.json()
        dispatch(ADD_COMPANY, data.company)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Edit a company
 *
 * @param dispatch
 * @param oldContact The former company data
 * @param newContact The new company data
 */
export const editCompany = ({ dispatch }, oldCompany, newCompany) => {
  dispatch(REQUEST_COMPANY)
  Vue.http
    .put('company/' + newCompany.id, newCompany)
    .then(
      (response) => {
        dispatch(UPDATE_COMPANY, oldCompany, newCompany)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a user
 *
 * @param dispatch
 * @param user
 */
export const deleteCompany = ({ dispatch }, company) => {
  dispatch(REQUEST_COMPANY)
  Vue.http.delete('company/' + company.id)
    .then(
      (response) => {
        dispatch(DELETE_COMPANY, company)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/companiesActions.js